import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import {
  DropDownList,
  DropDownListFilterChangeEvent,
  DropDownListProps,
} from '@progress/kendo-react-dropdowns';
import { useEffect, useState } from 'react';

interface SearchDropDownProps extends DropDownListProps {
  options: any[];
}

const DropDownWithSearch = (props: SearchDropDownProps) => {
  const { options } = props;

  const [data, setData] = useState(options);

  useEffect(() => {
    setData(options);
  }, [options]);

  const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) =>
    filterBy(options, filter);

  const filterChange = (event: DropDownListFilterChangeEvent) => setData(filterData(event.filter));

  return <DropDownList filterable onFilterChange={filterChange} data={data} {...props} />;
};

export default DropDownWithSearch;
